import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgArrowCode = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M17.27 6h-2.61l5 6-5 6h2.61l5-6-5-6ZM6.73 6l-5 6 5 6h2.61l-5-6 5-6H6.73Z"
    />
  </svg>
);
export default SvgArrowCode;
